import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { WebsocketConnectionStatus, WebsocketService } from "@dtm-frontend/shared/websocket";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { first, timer } from "rxjs";
import { reloadComponent } from "../../utils/reload-component";

const NAVIGATION_INTERVAL_MS = 5000;

export enum ConnectionIssueType {
    InvalidClient = "invalid-client",
    CannotAcceptConnection = "cannot-accept-connection",
}

interface ConnectionIssueComponentState {
    issueType: ConnectionIssueType | undefined;
}

@UntilDestroy()
@Component({
    selector: "dtm-ui-connection-issue",
    templateUrl: "./connection-issue.component.html",
    styleUrls: ["./connection-issue.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class ConnectionIssueComponent implements OnInit {
    protected readonly ConnectionIssueType = ConnectionIssueType;

    @Input({ required: true }) public set issueType(value: ConnectionIssueType) {
        this.localStore.setState({
            issueType: value,
        });
    }

    protected readonly issueType$ = this.localStore.selectByKey("issueType");

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly websocketService: WebsocketService,
        private readonly localStore: LocalComponentStore<ConnectionIssueComponentState>
    ) {
        this.localStore.setState({
            issueType: this.route.snapshot.data.issueType,
        });

        timer(NAVIGATION_INTERVAL_MS)
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                reloadComponent(this.router);
            });
    }

    public ngOnInit(): void {
        if (this.localStore.selectSnapshotByKey("issueType") === ConnectionIssueType.InvalidClient) {
            this.websocketService.connectionStatus$
                .pipe(
                    first((status) => status === WebsocketConnectionStatus.Connected),
                    untilDestroyed(this)
                )
                .subscribe(() => {
                    if (this.route.snapshot.data.validUrl) {
                        this.router.navigateByUrl(this.route.snapshot.data.validUrl);
                    } else {
                        reloadComponent(this.router);
                    }
                });
        }
    }
}
